export default __webpack_public_path__ + "static/pres-45aab977d36977d92eb637008a13bda5.png";